import { CompoundButton } from '@fluentui/react-components';
import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import { LottieAnimation } from '../LottieAnimation';
import { useStyles } from './TaskButton.styles';
import { getCheckAnimationForApp } from './TaskButton.utils';

export type TaskButtonProps = {
    checked: boolean
    primaryContent: string
    secondaryContent: string
    showSecondaryContent?: boolean
    onClick: () => void
}

export const TaskButton = (props: TaskButtonProps) => {
    const styles = useStyles()
    const lottieRef = useRef<any>(null)
    const animationData = useMemo(() => getCheckAnimationForApp(), []);
    const { onClick } = props

    const handleClick = useCallback(() => {
        onClick()
    }, [onClick])

    useEffect(() => {
        if (props.checked) lottieRef.current?.play()
        else lottieRef.current?.reset()
    }, [props.checked])

    return (
        <CompoundButton
            className={props.checked ? styles.compoundButtonChecked : styles.compoundButton}
            icon={
                <div className={styles.checkBox}>
                    <LottieAnimation
                        ref={lottieRef}
                        animationData={animationData}
                        autoplay={false}
                        loop={false}
                    />
                </div>
            }
            secondaryContent={
                props.showSecondaryContent !== false ? props.secondaryContent : undefined
            }
            size="medium"
            onClick={handleClick}
        >
            {props.primaryContent}
        </CompoundButton>
    )
}

